// removed by extract-text-webpack-plugin
module.exports = {"block":"InstallPwaBubble__block-3nP2h","fadeIn":"InstallPwaBubble__fadeIn-30Px2","icon":"InstallPwaBubble__icon-qn9j-"};